// Lift hub sign-in tokens out of the URL before anything else runs.
//
// This MUST stay the first import in main.jsx: ES modules evaluate in import
// order, and Firebase Analytics (firebase.js) reads the address as soon as it
// initialises. See utils/urlSecrets.js.
import { captureUrlSecrets } from './utils/urlSecrets.js';

captureUrlSecrets();
